import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { ProductService } from 'src/services/productservice';
import { InstaService } from '../../services/insta.service';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss'],
})
export class InstagramComponent implements OnInit {
  constructor(
    private instaService: InstaService,
    private productService: ProductService,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}
  ngOnInit() {
    this.loadScripts();
  }
  loadScripts() {
    var lang = localStorage.getItem('language');
    var body = this.elementRef.nativeElement.querySelector('.one');
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://starling.crowdriff.com/js/crowdriff.js';
    script.async = true;
    script.defer = true;
    script.id = 'cr-init__f72c80bc28dabb31';
    script.lang = lang.toLowerCase();
    body.appendChild(script);
  }
}
